var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",staticStyle:{"height":"calc(100vh - 200px)"},attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config,"footer":_vm.footer}})}
var staticRenderFns = []

export { render, staticRenderFns }